export default class GiftInfo {
    id: number;
    giftCode: string;
    giftName: string;
    campaignCode: string;
    campaignId: number;
    remark: string;
    dataState: number = 1;
}